import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-dialog-heading',
  templateUrl: './dialog-heading.component.html',
  styleUrls: ['./dialog-heading.component.scss']
})
export class DialogHeadingComponent {

  @Input() heading: string;

  constructor() {
  }

}
